import React, { useState } from "react";
import Loader from "./Loader";
import UtilityHelper from "../../../service/utilities/UtilityHelper";
import { IconNormal } from "./Icon";
import AppTheme from "../../../service/app_config/AppTheme";

type PropsImageLogo = {
  className?: string;
  classNameWrap?: string;
  size?: number | string;
  url: string | null;
  bordered?: boolean | true;
  isProfile?: boolean | false;
  name: string;
  fixedHieght?: boolean;
  showErrorImage?: boolean;
  bgHexColor?: string;
  loadedCallBack?: (isValid?: boolean) => void;
};

export const LogoImage: React.FC<PropsImageLogo> = ({
  url,
  className,
  size,
  classNameWrap,
  fixedHieght = true,
  showErrorImage = false,
  loadedCallBack = undefined,
}) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isValid, setIsValid] = useState<boolean>(true);

  const handleLoad = () => {
    setIsLoading(false);
    if (loadedCallBack !== undefined && typeof loadedCallBack === "function")
      loadedCallBack(isValid);
  };

  const handleError = () => setIsValid(false);

  let style: any = {};
  if (size !== undefined) {
    if (UtilityHelper.isNumber(size.toString())) {
      style = { ...style, height: `${size}px`, width: `${size}px` };
    } else {
      style = { ...style, height: size, width: size };
    }
  }

  return (
    <div
      className={`overflow-hidden d-flex align-items-center justify-content-center position-relative ${
        classNameWrap ?? ""
      }`}
      style={isValid ? (fixedHieght ? style : isValid ? style : null) : null}
    >
      {isValid && (
        <img
          src={url!}
          className={`${className ?? ""} opacity-${isLoading ? 0 : 1} `}
          width={fixedHieght ? size : isValid ? size : 0}
          onLoad={handleLoad}
          onError={handleError}
          alt=""
        />
      )}

      {isLoading && isValid && (
        <div className="position-absolute">{Loader.normal()}</div>
      )}

      {!isValid && showErrorImage && (
        <span className="opacity-03">
          <IconNormal name="no_image" size={100} color={AppTheme.grey} />
        </span>
      )}
    </div>
  );
};

export const LogoRound: React.FC<PropsImageLogo> = ({
  url,
  className,
  size,
  isProfile = false,
  name = "",
  bgHexColor = "",
}) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const handleLoad = () => {
    setIsLoading(false);
  };

  let nameInit = "";
  let style: any = {};
  let styleText: any = {};

  let bgColorDefault = "bgcolor-white";

  if (size !== undefined) {
    if (UtilityHelper.isNumber(size.toString())) {
      style = { ...style, height: `${size}px`, width: `${size}px` };
      if (Number(size) > 99) {
        styleText = { ...styleText, zoom: `180%` };
      }
    }
  }

  if (UtilityHelper.isNotEmpty(name) && UtilityHelper.isEmpty(url!)) {
    const nameArr = name.split(" ");

    nameInit = `${name[0]}${name[1]}`;
    if (nameArr.length > 1) {
      nameInit = `${name[0]}${nameArr[nameArr.length - 1][0]}`;
    }

    if (UtilityHelper.isNotEmpty(bgHexColor)) {
      bgColorDefault = "";
      style = {
        ...style,
        borderColor: bgHexColor,
        backgroundColor: bgHexColor,
      };
    }
  }

  return (
    <div
      className={`theme-logo rounded-circle overflow-hidden d-flex align-items-center justify-content-center position-relative  ${
        isProfile || UtilityHelper.isEmpty(url!)
          ? `theme-profile-logo ${bgColorDefault}`
          : ""
      }`}
      style={{ ...style, backgroundImage: `url("${isLoading ? "" : url}")` }}
    >
      {UtilityHelper.isNotEmpty(url!) ? (
        <img
          src={url!}
          className={`rounded-circle ${
            className ?? ""
          } position-absolute opacity-0 `}
          width={size}
          onLoad={handleLoad}
          alt=""
        />
      ) : (
        <>
          {UtilityHelper.isNotEmpty(name) && (
            <div
              className={`text-uppercase color-black font-gotham-bold font-size-20_21`}
              style={styleText}
            >
              {nameInit}
            </div>
          )}
        </>
      )}

      {UtilityHelper.isNotEmpty(url!) && isLoading && Loader.normal()}
    </div>
  );
};
